class LWVideo extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const src = this.getAttribute('src') || '';
        let videoHTML = '';

        // Check welk type video het is
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
            const id = src.split('v=')[1] || src.split('/').pop();
            videoHTML = `<iframe src="https://www.youtube.com/embed/${id}" frameborder="0" allowfullscreen></iframe>`;
        } else if (src.includes('vimeo.com')) {
            const id = src.split('/').pop();
            videoHTML = `<iframe src="https://player.vimeo.com/video/${id}" frameborder="0" allowfullscreen></iframe>`;
        } else {
            // Standaard HTML5 video voor .mp4, .webm etc.
            videoHTML = `<video controls src="${src}"></video>`;
        }

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
                margin-bottom: 20px;
            }
            .video-wrapper {
                position: relative;
                padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
                height: 0;
                overflow: hidden;
                border-radius: 8px;
                background: #000;
            }
            .video-wrapper iframe, 
            .video-wrapper video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 0;
            }
        </style>
        <div class="video-wrapper">
            ${videoHTML}
        </div>
        `;
    }
}
customElements.define('lw-video', LWVideo);